import { View } from "react-native";
import { Text } from "react-native-paper";
import Modal from "../../../components/Modal";

type ModalProps = {
  onDismiss(): void;
  visible: boolean;
};

export const InsuranceModal = ({ onDismiss, visible }: ModalProps) => {
  return (
    <Modal onDismiss={onDismiss} visible={visible}>
      <View className="p-6 mb-6">
        <Text className="mb-6 text-title-5 font-700 text-ink-dark">Insurance</Text>
        <Text className="text-regular-normal font-400 mb-2">
          Insurance and the Member Assistance Program is a requirement of membership and must be paid with the membership dues.
          Insurance benefit amounts can be found on PGA.org and are subject to change.
        </Text>
      </View>
    </Modal>
  );
};

export const ContributionsModal = ({ onDismiss, visible }: ModalProps) => {
  return (
    <Modal onDismiss={onDismiss} visible={visible}>
      <View className="p-6 mb-6">
        <Text className="mb-6 text-title-5 font-700 text-ink-dark">Contributions</Text>
        <Text className="mb-3 text-regular-normal text-ink-dark">
          Dues, fees, assessments, contributions or gifts to the PGA of America are not tax deductible as charitable
          contributions.
        </Text>
        <Text className="mb-3 text-regular-normal text-ink-dark">
          However, they may be tax deductible as ordinary and necessary business expenses subject to restrictions imposed as a
          result of lobbying activities. The PGA of America estimates that the amount that may not be deducted based on lobbying
          is 6% of National Dues.
        </Text>
        <Text className="mb-3 text-regular-normal text-ink-dark">
          Your voluntary donation to the PGA Financial Assistance Fund is a tax deductible contribution that will be used to
          support scholarship recipients and benevolent relief efforts. The voluntary contribution to The PGA Medical and
          Disaster Relief Fund is not tax deductible as a charitable contribution.
        </Text>
        <Text className="text-regular-normal text-ink-dark">
          PGA Medical and Disaster Relief is available to PGA Members only.
        </Text>
      </View>
    </Modal>
  );
};
